import {SET_LAST_LOCATION} from "../types";

export function setLastLocation(location) {
    return function(dispatch) {
        return dispatch({ type: SET_LAST_LOCATION, location });
    }
}
